import { WidgetType } from '@codemirror/view';

import * as styles from '../FilterField.sty.js';

/** @internal */
export class DeleteStatementWidget extends WidgetType {
  readonly from: number;
  readonly to: number;
  readonly buttonStyles: string;

  constructor(from: number, to: number, incomplete: boolean) {
    super();

    this.from = from;
    this.to = to;
    this.buttonStyles = styles.filterStatementDeleteButton({
      incomplete: incomplete,
    });
  }

  toDOM() {
    const wrapper = document.createElement('span');
    wrapper.setAttribute('aria-hidden', 'true');
    wrapper.classList.add(styles.filterStatementDeleteWidget);
    const range = document.createRange();
    const deleteButton = range.createContextualFragment(
      // Don't add spaces/linebreaks to the string since they will end up in the markup as well.
      `<button type="button" class="${this.buttonStyles}" tabindex="-1" aria-label="Delete filter statement" data-dt-children-name="Remove" data-from="${this.from}" data-to="${this.to}"><svg class="${styles.filterStatementDeleteIcon}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><path d="M8.01524 8.76946L11.9663 12.5459L12.8337 11.7167L8.88272 7.94032L12.7085 4.28358L11.841 3.45443L8.01524 7.11117L4.15895 3.42529L3.29148 4.25444L7.14776 7.94032L3.16626 11.7459L4.03374 12.575L8.01524 8.76946Z" fill="currentColor"/></svg></button>`,
    );
    wrapper.appendChild(deleteButton);
    return wrapper;
  }

  ignoreEvent() {
    return false;
  }
}
